module.exports = __webpack_public_path__ + "static/media/hubspot-close.5b2ab852.svg";